export default {
      id: "arrow-down-usage",
      viewBox: "0 0 18 18",
      url: __webpack_public_path__ + "img/icons.a60dffc6.svg#arrow-down",
      toString: function () {
        return this.url;
      }
    }